import { render, staticRenderFns } from "./editRol.vue?vue&type=template&id=43694bdd&"
import script from "./editRol.vue?vue&type=script&lang=js&"
export * from "./editRol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports